import classnames from 'classnames'
import { PropsWithChildren, FC } from 'react'
import { Select, Input } from 'antd'
import { DEFAULT_SEARCH_TYPE } from '@OpsQuality/JobRequestList/constants'
import styles from '@OpsQuality/styles.css'

import Box from '~/core/Box'

const { Group, Search } = Input

const SEARCH_FIELD_STYLE = classnames(
    'certain-category-search',
    styles.searchField,
)

type TopSearchPropsType = {
    pendingSearchType?: string
    pendingSearchString: string
    searchType?: string
    onEnterSearch: (value: string, defaultSearchValue: string) => void
    setPendingSearchType: (searchType: string) => void
    setPendingSearchString: (searchString: string) => void
}

export const QualityTopSearch: FC<
    PropsWithChildren<TopSearchPropsType>
> = props => {
    const {
        pendingSearchType,
        setPendingSearchType,
        setPendingSearchString,
        onEnterSearch,
        pendingSearchString,
        searchType,
    } = props

    const defaultSearchValue =
        pendingSearchType || searchType || DEFAULT_SEARCH_TYPE

    return (
        <Box
            flex={1}
            justifyContent="between"
            className={styles.topFilterContainerStyle}
        >
            <form action="#" onSubmit={evt => evt.preventDefault()}>
                <Group compact>
                    <Select
                        defaultValue={defaultSearchValue}
                        onChange={(value: string) =>
                            setPendingSearchType(value)
                        }
                    >
                        <Select.Option value="jobRequest">
                            Job request
                        </Select.Option>
                        <Select.Option value="salesOrder">
                            Sales order
                        </Select.Option>
                    </Select>
                    <Search
                        placeholder="Search by name"
                        onSearch={value =>
                            onEnterSearch(value, defaultSearchValue)
                        }
                        onChange={evt => {
                            setPendingSearchString(evt.target.value)
                        }}
                        allowClear
                        className={SEARCH_FIELD_STYLE}
                        value={pendingSearchString}
                        type="search"
                    />
                    <input
                        id="SearchButton"
                        type="button"
                        value="Search"
                        style={{ display: 'none' }}
                    />
                </Group>
            </form>
        </Box>
    )
}
